const LANGUAGES = ['en', 'es'];

// Language display names (for UI)
const LANGUAGE_NAMES = {
  en: 'English',
  es: 'Español',
};

// Language flags (for UI)
const LANGUAGE_FLAGS = {
  en: '🇺🇸',
  es: '🇪🇸',
};

const DEFAULT_LANGUAGE = 'en';

const FALLBACK_LANGUAGE = 'en';

const TRANSLATIONS_DIR = './translations';

const DEFAULT_NAMESPACE = 'common';

module.exports = {
  LANGUAGES,
  LANGUAGE_NAMES,
  LANGUAGE_FLAGS,
  DEFAULT_LANGUAGE,
  FALLBACK_LANGUAGE,
  TRANSLATIONS_DIR,
  DEFAULT_NAMESPACE,
};
